export const LANGUAGES_PAIR_METADATA_TYPE = 'languages_pair';
export const isLanguagesPair = (metadataType: string): boolean => metadataType === LANGUAGES_PAIR_METADATA_TYPE;
